export const mockData = {
  name: "Mar d'Areia",
  rating: 4.6,
  reviewCount: 1100,
  phone: "+351 931 407 224",
  address: "Rua da Fonte do Cabo 49, 2655-285 Ericeira, Portugal",
  openingTime: "12:00",
  instagram: "https://www.instagram.com/mardareia",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Mar+d'Areia+Ericeira",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3108.8847385867757!2d-9.417929!3d38.962778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDU3JzQ2LjAiTiA5wrAyNScwNC41Ilc!5e0!3m2!1sen!2spt!4v1234567890",

  menuCategories: [
    {
      name: "Especialidades de Peixe Grelhado",
      items: [
        {
          name: "Sardinhas",
          description: "Sardinhas portuguesas frescas grelhadas no carvão"
        },
        {
          name: "Robalo Grelhado",
          description: "Robalo grelhado com azeite e ervas aromáticas"
        },
        {
          name: "Dourada Grelhada",
          description: "Dourada grelhada no carvão"
        },
        {
          name: "Captura do Dia",
          description: "Pergunte ao nosso staff sobre a seleção de hoje"
        }
      ]
    },
    {
      name: "Pratos de Marisco",
      items: [
        {
          name: "Amêijoas à Bulhão Pato",
          description: "Amêijoas cozinhadas com alho, coentros e vinho branco"
        },
        {
          name: "Gambas Grelhadas",
          description: "Gambas grandes grelhadas na perfeição"
        },
        {
          name: "Mariscada Mista",
          description: "Uma seleção do nosso melhor marisco grelhado"
        }
      ]
    },
    {
      name: "Entradas Tradicionais",
      items: [
        {
          name: "Pataniscas de Bacalhau",
          description: "Pataniscas tradicionais de bacalhau"
        },
        {
          name: "Pão Fresco e Azeitonas",
          description: "Pão regional com azeitonas portuguesas"
        },
        {
          name: "Salada da Casa",
          description: "Salada fresca com tomate e cebola"
        }
      ]
    },
    {
      name: "Bebidas e Sobremesas",
      items: [
        {
          name: "Vinho Verde",
          description: "Vinho verde português fresco"
        },
        {
          name: "Vinho Tinto da Casa",
          description: "Vinhos tintos portugueses selecionados"
        },
        {
          name: "Arroz Doce",
          description: "Arroz doce tradicional português com canela"
        },
        {
          name: "Fruta Fresca da Época",
          description: "Fruta fresca regional da época"
        }
      ]
    }
  ],

  reviews: [
    {
      author: "Maria S.",
      text: "O peixe mais fresco que já comi! O robalo grelhado estava perfeito. Experiência portuguesa autêntica."
    },
    {
      author: "João D.",
      text: "Óptima relação qualidade-preço. O staff é extremamente simpático e o ambiente parece um restaurante familiar local."
    },
    {
      author: "Ana R.",
      text: "As melhores sardinhas da Ericeira! A grelha a carvão dá um sabor tão autêntico. Recomendo vivamente!"
    }
  ],

  galleryImages: [
    {
      url: "https://customer-assets.emergentagent.com/job_db5f6d10-80a4-4c8d-b63b-ce208e1aca3f/artifacts/xyopmepz_Screenshot%202026-01-03%20at%2014.55.34.png",
      alt: "Peixe fresco grelhado"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_db5f6d10-80a4-4c8d-b63b-ce208e1aca3f/artifacts/cj1xvkf0_Screenshot%202026-01-03%20at%2014.55.43.png",
      alt: "Especialidades grelhadas"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_db5f6d10-80a4-4c8d-b63b-ce208e1aca3f/artifacts/x8blpmv6_Screenshot%202026-01-03%20at%2014.56.00.png",
      alt: "Salada e legumes frescos"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_db5f6d10-80a4-4c8d-b63b-ce208e1aca3f/artifacts/2pk1zkv2_Screenshot%202026-01-03%20at%2014.56.15.png",
      alt: "Peixe fresco do dia"
    },
    {
      url: "https://images.pexels.com/photos/2233733/pexels-photo-2233733.jpeg",
      alt: "Grelha a carvão"
    },
    {
      url: "https://images.pexels.com/photos/3650159/pexels-photo-3650159.jpeg",
      alt: "Sardinhas frescas"
    },
    {
      url: "https://images.pexels.com/photos/7538072/pexels-photo-7538072.jpeg",
      alt: "Prato de marisco"
    },
    {
      url: "https://images.pexels.com/photos/17243891/pexels-photo-17243891.jpeg",
      alt: "Amêijoas"
    }
  ]
};
